module.exports = __webpack_public_path__ + "ionicons.19e65b89cee273a249fb.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/ionicons/fonts/ionicons.eot?v=2.0.1
// module id = ../../../../ionicons/fonts/ionicons.eot?v=2.0.1
// module chunks = vendor